// @ts-nocheck
import InputLabelField from '@/components/form-control/InputLabelField'
import { useAuthContext } from '@/features/auth/context'

import { useConfigUI } from '@/features/config/context'
import {
  useSearchControllerLocation,
  useUpdateLocation,
} from '@/features/config/hooks/sitesandlocations'
import { SearchParams } from '@/types/common'
import { yupResolver } from '@hookform/resolvers/yup'
import { LoadingButton } from '@mui/lab'
import { Button, Container, Stack, Typography } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'

interface LocationViewProps {
  id?: string
  name?: string
  siteId?: string
}

const schema = yup
  .object({
    location: yup.string().required('Location is required'),
  })
  .required()

const LocationView = ({ id, name, siteId }: LocationViewProps) => {
  const { closeSidebar } = useConfigUI()
  const { interfaceId } = useAuthContext()
  const { mutate: updateLocation, isLoading: loadingUpdateLocation } =
    useUpdateLocation()

  const [searchParams] = useState<SearchParams>({
    interfaceId: interfaceId,
    locationId: Number(id),
  })
  const { data } = useSearchControllerLocation(searchParams)

  let selectedData = data?.selectedControllers || []

  let listData: {
    id: string
    interfaceId: any
    address: string
    status: boolean
  }[] = []

  for (let i = 0; i < selectedData.length; i++) {
    listData.push({
      id: selectedData[i].id,
      interfaceId: selectedData[i].interfaceId,
      address: selectedData[i].address,
      status: selectedData[i].status,
    })
  }
  // const handleSearchSelected = debounce(
  //   (event: React.ChangeEvent<HTMLInputElement>) => {
  //     const value = `${event.target.value}`
  //     setSearchParams({
  //       ...searchParams,
  //       selectedKeyword: value,
  //     })
  //   },
  //   500,
  // )
  // const handleSearchUnSelected = debounce(
  //   (event: React.ChangeEvent<HTMLInputElement>) => {
  //     const value = `${event.target.value}`
  //     setSearchParams({
  //       ...searchParams,
  //       unselectedKeyword: value,
  //     })
  //   },
  //   500,
  // )

  // const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   if (event.target.checked) {
  //     listData.push({
  //       id: event.target.id,
  //       address: event.target.value,
  //       interfaceId: interfaceId,
  //       status: event.target.checked,
  //     })
  //   } else {
  //     let index = listData.findIndex(
  //       (element) =>
  //         element.id.toString() === event.target.id &&
  //         element.address.toString() === event.target.value,
  //     )
  //     listData[index].status = event.target.checked
  //   }
  // }
  const inputRefSiteName = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (inputRefSiteName.current) {
      inputRefSiteName.current.focus()
    }
  }, [])
  const form = useForm({
    defaultValues: {
      location: name,
    },
    resolver: yupResolver(schema),
  })

  const handleSave = (data: any) => {
    updateLocation({
      id: Number(id),
      siteId: Number(siteId),
      interfaceId: interfaceId,
      name: data.location,
      controllerIds: listData,
    })
  }

  return (
    <Container sx={{ width: '440px' }}>
      <form onSubmit={form.handleSubmit(handleSave)}>
        <Stack sx={{ padding: '34px 11px' }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography
              color="text.main"
              sx={{
                fontWeight: '500',
                fontSize: '14px',
                color: '#000000',
              }}
            >
              Edit Location
            </Typography>
            <Stack direction="row">
              <Button
                size="small"
                color="secondary"
                sx={{ marginRight: '7px', width: '85px' }}
                onClick={() => closeSidebar()}
              >
                Cancel
              </Button>
              <LoadingButton
                loading={loadingUpdateLocation}
                color="primary"
                variant="contained"
                sx={{ minWidth: '72px', padding: 0 }}
                type="submit"
              >
                Save
              </LoadingButton>
            </Stack>
          </Stack>

          <InputLabelField
            name="location"
            form={form}
            label="Location"
            placeholder="Location name"
            style={{
              height: 50,
              borderRadius: '4px',
              width: { xs: '370px' },
              marginTop: '8px',
            }}
            padding="8px 16px"
            required
          />

          {/* <Box
            sx={{
              width: '653px',
              marginTop: '11px',
              border: '1px solid #EFEFEF',
            }}
          >
            <Box
              sx={{
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                backgroundColor: '#EFEFEF',
                padding: '8px',
                color: '#333333',
                fontWeight: '600',
              }}
            >
              Selected Decoders
            </Box>
            <Box>
              <InputBase
                placeholder="Search decoders"
                onChange={handleSearchSelected}
                sx={{
                  width: '100%',
                  height: '32px',
                  backgroundColor: 'common.white',
                  borderBottom: '1px solid #D7D7D7',
                  padding: '8px',
                  [`& .MuiInputBase-input`]: {
                    fontSize: '12px',
                    fontWeight: '400',
                    lineHeight: '115%',
                    color: 'grey.600',
                  },
                }}
                endAdornment={
                  <InputAdornment position="end" sx={{ color: '#747474' }}>
                    <SearchIcon />
                  </InputAdornment>
                }
              />
            </Box>
            <Box
              sx={{
                overflow: 'auto',
                maxHeight: '252px',
              }}
            >
              <FormGroup>
                {data?.selectedControllers.map((item, index) => (
                  <FormControlLabel
                    sx={{
                      height: '40px',
                      paddingLeft: '14px',
                    }}
                    key={index}
                    control={
                      <Checkbox
                        checkedIcon={<CheckIcon />}
                        icon={<UnCheckIcon />}
                        id={item.id.toString()}
                        value={item.address.toString()}
                        onChange={handleChange}
                        defaultChecked
                      />
                    }
                    label={item.name}
                  />
                ))}
              </FormGroup>
            </Box>
          </Box>
          <Box
            sx={{
              width: '653px',
              marginTop: '11px',
              border: '1px solid #EFEFEF',
            }}
          >
            <Box
              sx={{
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                backgroundColor: '#EFEFEF',
                padding: '8px',
                color: '#333333',
                fontWeight: '600',
              }}
            >
              All Orther Decoders
            </Box>
            <Box>
              <InputBase
                placeholder="Search decoders"
                onChange={handleSearchUnSelected}
                sx={{
                  width: '100%',
                  height: '32px',
                  backgroundColor: 'common.white',
                  borderBottom: '1px solid #D7D7D7',
                  padding: '8px',
                  [`& .MuiInputBase-input`]: {
                    fontSize: '12px',
                    fontWeight: '400',
                    lineHeight: '115%',
                    color: 'grey.600',
                  },
                }}
                endAdornment={
                  <InputAdornment position="end" sx={{ color: '#747474' }}>
                    <SearchIcon />
                  </InputAdornment>
                }
              />
            </Box>
            <Box
              sx={{
                overflow: 'auto',
                maxHeight: '252px',
              }}
            >
              <FormGroup>
                {data?.unselectedControllers.map((item, index) => (
                  <FormControlLabel
                    sx={{
                      height: '40px',
                      paddingLeft: '14px',
                    }}
                    key={index}
                    control={
                      <Checkbox
                        checkedIcon={<CheckIcon />}
                        icon={<UnCheckIcon />}
                        id={item.id.toString()}
                        value={item.address.toString()}
                        onChange={handleChange}
                      />
                    }
                    label={item.name}
                  />
                ))}
              </FormGroup>
            </Box>
          </Box> */}
        </Stack>
      </form>
    </Container>
  )
}

export default LocationView
